import type {
  TeaserBaseProps,
  TeaserMediaProps,
  TeaserTextProps,
  TeaserVignetteProps,
} from '@bonniernews/dn-design-system-web/assets/types/teaser-props.ts'

import { formatClassString } from '@bonniernews/dn-design-system-web/helpers/formatClassString.ts'
import { Body, Media, Title, Vignette } from '@bonniernews/dn-design-system-web/helpers/teaser.tsx'

import { TeaserCard } from '@bonniernews/dn-design-system-web/components/teaser-card/teaser-card.tsx'

interface TeaserTextOnImageProps extends TeaserBaseProps, TeaserVignetteProps, TeaserMediaProps, TeaserTextProps {}

/**
 * - GitHub: [BonnierNews/dn-design-system/web/src/components/teaser-text-on-image](https://github.com/BonnierNews/dn-design-system/tree/main/web/src/components/teaser-text-on-image)
 * - Storybook: [TeaserTextOnImage](https://designsystem.dn.se/?path=/docs/section-teasertextonimage--docs)
 *
 * The component will not include styling by itself. Make sure to include the right styles for the component. See example below:
 * `@use '@bonniernews/dn-design-system-web/components/teaser-text-on-image)/teaser-text-on-image.scss'`
 */

export const TeaserTextOnImage = ({
  title,
  targetLink,
  vignette,
  text,
  media,
  classNames,
  attributes,
  areaType,
}: TeaserTextOnImageProps) => {
  const classes = formatClassString(['ds-teaser--text-on-image', classNames])

  return (
    <TeaserCard areaType={areaType} targetLink={targetLink} classNames={classes} attributes={attributes}>
      <div className='ds-teaser__content'>
        <Media media={media} />
        <div className='ds-teaser__text-content'>
          <Vignette vignette={vignette} />
          <Title title={title} />
          <Body text={text} />
        </div>
      </div>
    </TeaserCard>
  )
}
